import React, { useEffect, useMemo, useState } from "react";
import { Select } from "../../../../components";
import { useThemesContext } from "../../context/ThemeProvider";
import useIFrameEvents from "./hooks/useIFrameEvents";

const SelectTemplate = (props) => {

  const { templates } = props;

  const { onChangeTemplate } = useIFrameEvents();
  const {
    setSelectedTemplate,
    selectedTemplate,
    resetMenuState,
    products,
    feedbacks, pages,
    tickets
  } = useThemesContext();

  const [selectValue, setSelectValue] = useState(null);
  const [value, setValue] = useState(null);

  //disabled
  const hasProducts = !!products?.length;
  const hasFeedbacks = feedbacks?.length;
  const hasTickets = tickets?.length;
  const hasCustomPages = pages?.some(({ template_type }) => template_type === 'PAGE');

  const options = useMemo(() => {
    if(templates) {
      return Object.entries(templates).map(([id, template]) =>
          ({ label: template.name, value: id, templateType: template.template_type })
      )
    } else {
      return []
    }
  }, [templates]);


  const selectHandleChange = (e) => {
    const targetTemplate = templates[e.target.value];

    setSelectValue(e.target.value);
    setSelectedTemplate(targetTemplate);
    onChangeTemplate(targetTemplate);
    resetMenuState();
  };

  useEffect(() => {
    if (selectedTemplate) {
      setValue({
        label: selectedTemplate.name,
        value: selectedTemplate.name,
      });
      setSelectValue(selectedTemplate.name);
    }
  }, [selectedTemplate]);

  return (
    <div style={{ marginRight: ".75rem" }}>
      <Select
          options={options}
          size="large"
          value={selectValue}
          onChange={selectHandleChange}
      />
    </div>
  );
};

export default SelectTemplate;
